import { useModal } from "../../../Components/Modal";
import { useState, useEffect } from "react";
import CrudPage from "../../../Components/CrudPage";
import Text from "../../../Components/Text";
import { getAllRegisterEntries } from "../../../Model/RegisterEntries";
import { CashAccountingForm } from "./CashAccountingForm";

export const CashAccounting = ({ title = "Kassenabrechnung erstellen", alternateAction = null, bg = "bg-gray-100" }) => {
    const { ModalView, openModal, closeModal } = useModal()
    const [registerEntries, setRegisterEntries] = useState([])

    useEffect(() => {
        fetchRegisterEntries()
    }, [alternateAction])

    const fetchRegisterEntries = async () => {
        if (!alternateAction) {
            const data = await getAllRegisterEntries()
            setRegisterEntries(data.filter(p => p.startAmount === null))
        } else {
            const data = await alternateAction()
            setRegisterEntries(data)
        }
    }

    const handleEditClick = (e, item) => {
        openModal(
            <CashAccountingForm item={item} afterAction={() => {
                fetchRegisterEntries()
                closeModal()
            }} />
        )
    }

    const mainView = () => (
        <div className="w-full h-full flex flex-col min-h-0 p-3">
            <div className="flex-1 min-h-0 overflow-y-auto">
                <CrudPage
                    title={title}
                    noItemTitle={"Keine Kasse zum abrechnen"}
                    items={registerEntries}
                    displayMethod={(item) => (
                        <>
                            <Text type="itemmain">{item.user.firstName} {item.user.lastName}</Text>
                            <Text type="itemtext">{`Kasseninhalt SOLL: ${item.finalAmount}`}</Text>
                            <Text type="itemtext">{`Kasseninhalt IST: ${item.startAmount ? item.startAmount : "Nicht abgerechnet"}`}</Text>
                        </>
                    )}
                    crudActions={[
                        { type: "edit", color: "black", action: handleEditClick, icon: "edit" }]}
                />
            </div>
        </div>
    )

    return (
        <div className={`w-full h-full flex flex-col min-h-0 ${bg}`}>
            {mainView()}
            <ModalView classNames="w-auto" />
        </div>
    );
}